import React from 'react'
import { Link } from 'react-router-dom'

function BrandItem ({list, spaceFlag}) {
    return (
        list.map((item, index) => {
            return (
                <li className={`${spaceFlag}`} key={index}>
                    <Link to={`${item.toUrl}?flag=${item.id}`} className="lx-flex-column-center">
                        <img className="brand-img" src={item.imgUrl} alt="brand" />
                        <span className="title">{ item.title }</span>
                    </Link>
                </li>
            )
        })
    ) 
}

export default BrandItem;